/* Wing Cheong - WhatsApp product enquiry that carries the option, quantity and link.
   Loaded on product pages by sections/wc-wa-qty.liquid. */
(function () {
  'use strict';
  var form = document.querySelector('.js-pform');
  var links = Array.prototype.slice.call(document.querySelectorAll('.js-wa-product'));
  var WC = window.WC || {};
  if (!form || !links.length || !WC.wa) return;

  var ms = (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('ms') === 0;
  var T = ms ? {
    intro: 'Hi Wing Cheong, saya berminat dengan:', qty: 'Kuantiti:', pack: 'pek', packs: 'pek', pcs: 'biji',
    ask: 'Boleh kongsi harga dan stok?', area: 'Kawasan penghantaran:'
  } : {
    intro: "Hi Wing Cheong, I'm interested in:", qty: 'Quantity:', pack: 'pack', packs: 'packs', pcs: 'pcs',
    ask: 'Could you share the price and stock?', area: 'Delivery area:'
  };

  var root = form.closest('[data-section]') || document;
  var qtyInput = form.querySelector('input[name="quantity"]');
  var idInput = form.querySelector('.js-variant-id');
  var priceEl = root.querySelector('.pinfo__price .price');
  var packQty = priceEl ? Number(priceEl.getAttribute('data-qty')) || 0 : 0;
  var product = null;
  try {
    var el = root.querySelector('.js-product-json');
    product = el ? JSON.parse(el.textContent) : null;
  } catch (e) { product = null; }
  if (!product || !product.variants) return;

  function currentVariant() {
    var id = idInput ? String(idInput.value) : '';
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === id) return product.variants[i];
    }
    return product.variants[0] || null;
  }

  function build() {
    var n = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    var v = currentVariant();
    var name = product.title + (v && v.title && v.title !== 'Default Title' ? ' (' + v.title + ')' : '');
    var line = T.qty + ' ' + n;
    if (packQty > 1) line += ' ' + (n > 1 ? T.packs : T.pack) + ' (' + (n * packQty).toLocaleString('en-MY') + ' ' + T.pcs + ')';
    links.forEach(function (a) {
      var base = a.getAttribute('data-link') || (location.origin + location.pathname);
      var text = [T.intro, name, line, base + (v ? '?variant=' + v.id : ''), '', T.ask, T.area + ' '].join('\n');
      a.href = 'https://wa.me/' + WC.wa + '?text=' + encodeURIComponent(text);
    });
  }

  /* theme.js rewrites these links on option change and steps the quantity itself; run after it */
  function later() { setTimeout(build, 0); }
  form.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.js-step')) later(); });
  if (qtyInput) {
    qtyInput.addEventListener('input', build);
    qtyInput.addEventListener('change', build);
  }
  Array.prototype.forEach.call(root.querySelectorAll('.js-opt input'), function (i) { i.addEventListener('change', later); });
  build();
})();
